import { render, staticRenderFns } from "./MonAni.vue?vue&type=template&id=62a0670c&scoped=true"
import script from "./MonAni.vue?vue&type=script&lang=js"
export * from "./MonAni.vue?vue&type=script&lang=js"
import style0 from "./MonAni.vue?vue&type=style&index=0&id=62a0670c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a0670c",
  null
  
)

export default component.exports